import { render, staticRenderFns } from "./modalGuiasEnvio.vue?vue&type=template&id=3890460e&"
import script from "./modalGuiasEnvio.vue?vue&type=script&lang=js&"
export * from "./modalGuiasEnvio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports